// extracted by mini-css-extract-plugin
export var container = "_ai-0";
export var icon = "_ai-1";
export var text = "_ai-2";